module.exports = __webpack_public_path__ + "media/images/front/general_dentistry_study_club-8566cc1dab8ea896fe6eff6e98f2e81d.png";